/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Heading, Stack, Text, Divider } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { map, get } from 'lodash';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import Navigation from 'modules/app/shopify/navigation';
import AnnotatedSection from 'components/annotated-section';
import Card from 'components/card';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import AnnotatedSectionSkeleton from 'components/skeleton-loader/annotated-section-skeleton';
import aecSdk from 'lib/app-ec-sdk';
import cecSdk from 'lib/customer-ec-sdk';
import Notice from 'components/notice';
import { successNotice, errorNotice } from 'state/notices/actions';
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import Icon from 'components/icon';
import { requestConnection, saveConnection } from 'state/connections/actions';
import { requestConnectionTypes } from 'state/connection-types/actions';
import JumpingDots from 'components/jumping-dots';
import { getCurrentUsername } from 'state/current-user/selectors';

//input
import SelectResources from './select-resources';
import CreateConnection from './create-connection';

/**
 * Style dependencies
 */
import './styles.scss';

const AppCallback = ({ callback, ...props }) => {
    const [saving, setSaving] = useState(false);
    const [requesting, setRequesting] = useState(true);
    const [error, setError] = useState(false);
    const [values, setValues] = useState({});

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {

            const queryParameters = new URLSearchParams(window.location.search);
            const code = queryParameters.get("code");
            const hmac = queryParameters.get("hmac");
            const host = queryParameters.get("host");
            const shop = queryParameters.get("shop");
            const timestamp = queryParameters.get("timestamp");

            let response = await aecSdk.callback().verifyCallback(code, hmac, host, shop, timestamp, props.username);

            if(response) {
                setValues(response);

                localStorage.setItem('token', response.response.Token);
                localStorage.setItem('shopUrl', response.response.ShopUrl);
                localStorage.setItem('clientId', response.connection.connectionDetails.ApiKey);
                localStorage.setItem('sharedSecret', response.connection.connectionDetails.SharedSecret);

                if(response.connection && response.connection.id !== "undefined") {
                    localStorage.setItem('connectionName', response.connection.name);
                    localStorage.setItem('groupCode', response.connection.groupCode);
                    localStorage.setItem('connectionConfig', JSON.stringify(response.connection.config));
                }
            } else {
                setError("Error processing data");
            }

        } catch (error) {
            setError(error.message);
        }

        setRequesting(false);
    };

    if (requesting) {
        return (
            <Main>
                <Stack space='large'>
                    <Navigation section='general' />
                    <AnnotatedSectionSkeleton />
                </Stack>
            </Main>
        );
    }

    return (
        (get(values, 'status') == 200) ? (<CreateConnection accessToken={get(get(values, 'response'), 'Token')} shopUrl={get(get(values, 'response'), 'ShopUrl')} apiKey={get(get(values, 'response'), 'ApiKey')} sharedSecret={get(get(values, 'response'), 'SharedSecret')} />) : 
        (<Main>
            <Stack space='large'>
                <Navigation section='general' />
                <Box paddingTop='xxlarge' paddingBottom='xxlarge'>
                    <Box display='flex' justifyContent='spaceBetween' alignItems='center' paddingBottom='xlarge'>
                        <Heading level='1'>App</Heading>
                    </Box>
                    <Divider />
                </Box>
                <Stack space='xlarge' dividers>
                    <AnnotatedSection>
                        <AnnotatedSection.Annotation
                            title='Api Config'
                            description='Enter your api details to allow us to communicate with your Shopify.'
                        />
                        <AnnotatedSection.Content>
                            <Stack space='large'>
                                <Card>
                                    <Card.Section>
                                        <Stack space='large'>
                                            <Box>
                                                <FormLabel>Response</FormLabel>
                                                <Text className="card__section-callbackinfo">Error: {get(values, 'status')}</Text>
                                            </Box>
                                            <Box>
                                                <Text size='small'>
                                                    {get(values, 'error')}
                                                </Text>
                                            </Box>
                                        </Stack>
                                    </Card.Section>
                                </Card>
                            </Stack>
                        </AnnotatedSection.Content>
                    </AnnotatedSection>
                    
                </Stack>
            </Stack>

        </Main>)
    );
};

export default connect(
    (state) => ({
        username: getCurrentUsername(state),
    }),
    {
        requestConnection,
        requestConnectionTypes,
        saveConnection,
        successNotice,
        errorNotice,
    },
)(AppCallback);
